import React from 'react';

const StarRating = ({
  reviewModal,
  setreviewModal,
  avgRating,
  preview,
  showPreview = false,
}) => {
  const MAX_STARS = 5; // Total number of stars
  const fullStars = Math.floor(avgRating); // Number of full stars
  const hasHalfStar = avgRating % 1 >= 0.5; // Check if there's a half star
  const emptyStars = MAX_STARS - fullStars - (hasHalfStar ? 1 : 0); // Remaining empty stars

  return (
    <>
      <div className="flex items-center gap-2 text-yellow-400">
        {/* Full stars */}
        {Array.from({ length: fullStars }).map((_, index) => (
          <svg
            key={`full-${index}`}
            className="w-5 h-5"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"></path>
          </svg>
        ))}

        {/* Half star */}
        {hasHalfStar && (
          <svg
            className="w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"></path>
            <path
              d="M12 17.27L5.82 21l1.64-7.03L2 9.24l7.19-.61L12 2v15.27z"
              fill="white"
            />
          </svg>
        )}

        {/* Empty stars */}
        {Array.from({ length: emptyStars }).map((_, index) => (
          <svg
            key={`empty-${index}`}
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73-1.64 7.03L12 17.27z"></path>
          </svg>
        ))}

        {/* Display the average rating */}
        <span className="text-[18px] text-[#0A0D14] font-[400]">
          {' '}
          (
          {Number(avgRating) % 1 === 0
            ? Number(avgRating)
            : Number(avgRating).toFixed(1)}{' '}
          Rating)
        </span>
      </div>
      {showPreview && (
        <div>
          <span
            onClick={() => {
              setreviewModal(!reviewModal);
            }}
            className="text-sm text-[#525866] ml-2 underline"
          >{`${preview || 0} reviews`}</span>
        </div>
      )}
    </>
  );
};

export default StarRating;
